import React from "react";
import { useSelector } from "react-redux";

import { useThunkDispatch } from "@redux/dispatcher";
import * as ImageViewerModule from "@redux/modules/value/imageViewer/imageViewer.module";
import * as ImageViewerSelectors from "@redux/modules/value/imageViewer/imageViewer.selectors";

import { ImageViewer } from "./imageViewer.component";

export type ImageViewerImage = {
    thumbnail: string;
    main: string;
    zoom?: string;
    maxZoom?: string;
    altText: string;
};

export type ImageViewerVideo = {
    thumbnail?: string;
    main: string;
    altText: string;
    videoId: string;
};

export type ImageViewerContainerProps = {
    images: Array<ImageViewerImage>;
    videos: Array<ImageViewerVideo>;
    usesdefaultimage?: string;
    defaultVideoThumbnailPath?: string;
    ecoChequesAccepted: boolean;
};

const ImageViewerContainer = ({
    images,
    videos,
    usesdefaultimage,
    defaultVideoThumbnailPath,
    ecoChequesAccepted,
}: ImageViewerContainerProps) => {
    const activeIndex = useSelector(ImageViewerSelectors.getActiveIndex);
    const dispatch = useThunkDispatch();
    const setActiveIndex = (index: number) => {
        dispatch(ImageViewerModule.update({ activeIndex: index }));
    };

    return (
        <ImageViewer
            activeIndex={activeIndex}
            setActiveIndex={setActiveIndex}
            images={images || []}
            videos={videos || []}
            usesDefaultImage={usesdefaultimage === "1"}
            defaultVideoThumbnailPath={defaultVideoThumbnailPath}
            ecoChequesAccepted={ecoChequesAccepted}
        />
    );
};

export { ImageViewerContainer };
